import React from "react";
import { SnackbarProvider } from 'notistack';
import BasicTextFields from "./BasicTextFields";

const SignupForm = () => {


  return (
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        style={{ direction: "rtl", fontFamily: "fanoos", maxWidth: "calc(100vw - 24px)", whiteSpace: "pre-line" }}
      >
        <BasicTextFields />
      </SnackbarProvider>
  );
};

export default SignupForm;
